window.CartUtils = (function () {
  async function addItemToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
      }),
    });

    if (!res.ok) {
      throw new Error('Add to cart failed');
    }
  }

  async function refreshCartDrawer(openDrawer = true) {
    const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    if (!res.ok) return;

    const sections = await res.json();
    const parser = new DOMParser();

    /* Cart Drawer */
    const drawerHTML = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');

    const drawer = document.querySelector('cart-drawer');
    drawer.classList.remove('is-empty');
    drawer.classList.add('active');

    const body = document.querySelector('body');
    body.classList.add('overflow-hidden');

    if (drawerHTML && drawer) {
      const newInner = drawerHTML.querySelector('.drawer__inner');
      const currentInner = drawer.querySelector('.drawer__inner');

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      } else {
        drawer.innerHTML = drawerHTML.innerHTML;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    /* =========================
   CART COUNT BUBBLE (FIXED)
    ========================== */
    const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
    const newBubble = bubbleDoc.querySelector('.cart-count-bubble');
    const currentBubble = document.querySelector('.cart-count-bubble');

    if (newBubble && currentBubble) {
      // Normal update
      currentBubble.innerHTML = newBubble.innerHTML;
    } else if (newBubble && !currentBubble) {
      // Cart was empty → bubble did not exist
      const cartLink = document.querySelector('a[href="/cart"]');
      if (cartLink) {
        cartLink.appendChild(newBubble);
      }
    }
  }

  return {
    addItemToCart,
    refreshCartDrawer,
  };
})();
